(() => {
  const source = document.getElementById('sw-water-matches');
  const labelsNode = document.getElementById('sw-water-labels');
  if (!source || !labelsNode || document.getElementById('sw-water-panel')) return;
  const data = JSON.parse(source.textContent);
  const labels = JSON.parse(labelsNode.textContent);
  const main = document.getElementById('MainContent');
  if (!main) return;
  const featured = [...main.querySelectorAll('[data-product-featured]')].find(el => {
    try { return JSON.parse(el.dataset.productFeatured).isMainProduct; } catch { return false; }
  });
  const formId = featured ? JSON.parse(featured.dataset.productFeatured).formID : null;
  const form = formId ? main.querySelector(formId) : main.querySelector('form[action*="/cart/add"]');
  if (!form) return;
  const element = (tag, cls, text) => {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text) el.textContent = text;
    return el;
  };
  const panel = element('section', 'sw-water-panel');
  panel.id = 'sw-water-panel';
  panel.setAttribute('aria-labelledby', 'sw-water-heading');
  const heading = element('h2', '', labels.heading);
  heading.id = 'sw-water-heading';
  const selected = element('p', 'sw-water-selected');
  selected.setAttribute('aria-live', 'polite');
  selected.setAttribute('aria-atomic', 'true');
  const grid = element('div', 'sw-water-grid');
  panel.append(heading, selected, grid, element('p', 'sw-water-note', labels.note));
  form.after(panel);
  let active = null;
  let lastInput = null;
  const hideOld = () => {
    main.querySelectorAll('.sw-compatible-products').forEach(el => el.hidden = true);
    [...main.querySelectorAll('h3')].filter(el => el.textContent.startsWith("Completa l'installazione:")).forEach(el => {
      let node = el;
      while (node) {
        const next = node.nextElementSibling;
        node.hidden = true;
        if (node.tagName === 'TABLE') break;
        node = next;
      }
    });
  };
  const render = id => {
    id = String(id || '');
    if (id === active) return;
    active = id;
    const entry = data.variants[id];
    grid.replaceChildren();
    selected.textContent = entry ? `${labels.selected}: ${entry.title}${entry.sku ? ' · ' + entry.sku : ''}` : '';
    if (!entry || !entry.cards.length) grid.append(element('p', 'sw-water-empty', labels.empty));
    else entry.cards.forEach(card => {
      const article = element('article', 'sw-water-card');
      article.dataset.variantId = card.id;
      article.append(element('span', 'sw-water-badge', '✓ ' + labels.compatible));
      if (card.image) {
        const imageLink = element('a', 'sw-water-image');
        imageLink.href = card.url;
        const image = document.createElement('img');
        image.src = card.image;
        image.alt = card.title;
        image.width = 180;
        image.height = 130;
        image.loading = 'lazy';
        imageLink.append(image);
        article.append(imageLink);
      } else article.append(element('div', 'sw-water-photo-empty', labels.photo));
      article.append(element('h3', '', card.title));
      article.append(element('p', 'sw-water-size', card.variant));
      if (card.sku) article.append(element('p', 'sw-water-code', card.sku));
      const link = element('a', 'sw-water-open', labels.open + ' →');
      link.href = card.url;
      link.setAttribute('aria-label', `${labels.open}: ${card.title}, ${card.variant}`);
      article.append(link);
      grid.append(article);
    });
    hideOld();
  };
  const input = () => form.querySelector('[name="id"]');
  const read = () => {
    const value = input()?.value;
    if (value && value !== lastInput) { lastInput = value; render(value); }
  };
  const initial = input()?.value || new URL(location.href).searchParams.get('variant') || labels.initial;
  lastInput = input()?.value || null;
  render(initial);
  let jqueryBound = false;
  const bindTheme = () => {
    if (!jqueryBound && window.jQuery_T4NT && featured) {
      window.jQuery_T4NT(featured).on('variant:changed.swWater', event => {
        if (event.target !== featured && !form.contains(event.target)) return;
        lastInput = input()?.value || null;
        render(event.currentVariant?.id);
      });
      jqueryBound = true;
    }
  };
  bindTheme();
  main.addEventListener('change', event => {
    if (form.contains(event.target) || featured?.contains(event.target)) setTimeout(read, 0);
  });
  window.addEventListener('popstate', () => {
    const id = new URL(location.href).searchParams.get('variant');
    if (id && data.variants[id]) render(id);
  });
  const timer = setInterval(() => {
    if (!panel.isConnected) return clearInterval(timer);
    bindTheme();
    read();
  }, 400);
})();
